import { render, staticRenderFns } from "./CardPortfolio.vue?vue&type=template&id=698b7ae1&"
import script from "./CardPortfolio.vue?vue&type=script&lang=js&"
export * from "./CardPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./CardPortfolio.vue?vue&type=style&index=0&id=698b7ae1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CardPortfolio.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports